export default __webpack_public_path__ + "static/media/651.16434651.gif";